export default __webpack_public_path__ + "static/media/website_dark_blue.351ed7db.svg";